






import { Component, Prop, Vue} from 'vue-property-decorator'

@Component({})

export default class SearchIcon extends Vue {}

